import { Component, inject, output } from "@angular/core";
import { KENDO_DIALOGS, WindowState } from "@progress/kendo-angular-dialog";
import { ICON_SETTINGS } from "@progress/kendo-angular-icons";
import { HighlightTheme, ThemeService } from "../../services/theme.service";
import { FormsModule } from "@angular/forms";
import { CustomMessagesService } from "../../services/custom-messages.service";
import { WINDOW_HEIGHT, WINDOW_WIDTH } from "../../app.const";
import { WindowTitlebarComponent } from "../window-titlebar/window-titlebar.component";

@Component({
  selector: "app-settings",
  imports: [KENDO_DIALOGS, FormsModule, WindowTitlebarComponent],
  providers: [{ provide: ICON_SETTINGS, useValue: { type: "svg" } }],
  templateUrl: "./settings.component.html",
  styleUrl: "./settings.component.scss",
})
export class SettingsComponent {
  private readonly themeService = inject(ThemeService);
  protected readonly customMessagesService = inject(CustomMessagesService);

  closed = output<void>();

  readonly themes: { label: string; value: HighlightTheme; color: string }[] = [
    { label: "Gris", value: "theme-select--1", color: "#8e8e93" },
    { label: "Rouge", value: "theme-select-0", color: "#ff3b30" },
    { label: "Orange", value: "theme-select-1", color: "#ff9500" },
    { label: "Jaune", value: "theme-select-2", color: "#ffcc00" },
    { label: "Vert", value: "theme-select-3", color: "#34c759" },
    { label: "Bleu", value: "theme-select-4", color: "#0a84ff" },
    { label: "Violet", value: "theme-select-5", color: "#af52de" },
    { label: "Rose", value: "theme-select-6", color: "#ff2d55" },
  ];

  selectedTheme = this.themeService.getCurrentTheme();
  public windowState: WindowState = "default";
  public windowWidth = WINDOW_WIDTH;
  public windowHeight = WINDOW_HEIGHT;

  public radio1 = {
    layout: "Landscape",
  };

  public radio2 = {
    layout: "Landscape",
  };

  selectTheme(theme: HighlightTheme): void {
    this.selectedTheme = theme;
    this.themeService.setHighlightTheme(theme);
  }

  close(): void {
    this.closed.emit();
  }
}
